/**
 * Stable CSS class names for E2E — Schedule history response modal.
 */
export const SDRM = {
    dialog: 'schedule-response-modal',
    title: 'schedule-response-modal__title',
    titleLayout: 'schedule-response-modal__title-layout',
    titleText: 'schedule-response-modal__title-text',
    closeButton: 'schedule-response-modal-input--button-close',
    closeIcon: 'schedule-response-modal__close-icon',
    content: 'schedule-response-modal__content',

    body: 'schedule-response-modal__body',
    row: 'schedule-response-modal__row',
    rowStatus: 'schedule-response-modal__row--status',
    rowCode: 'schedule-response-modal__row--code',
    rowBody: 'schedule-response-modal__row--body',
    rowLabel: 'schedule-response-modal__row-label',
    rowValue: 'schedule-response-modal__row-value',
} as const;

export const sdrmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

